import { toast } from "react-toastify";
import api from "../../utils/axiosConfig";
import { getParticipants } from "../../utils/groupSettings/settingsHelpers";

const useParticipants = ({ group, groupId, onSuccess }) => {
  const handleTogglePermission = async (userId) => {
    try {
      const res = await api.post("/groups/grant-access", {
        groupId,
        userId,
      });
      toast.success(res.data.message);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error("Grant access error:", err);
      toast.error("Failed to update user permission");
    }
  };

  const handleRemoveUserFromGroup = async (userId, userName) => {
    if (
      !window.confirm(
        `Are you sure you want to remove ${
          userName || "this user"
        } from the group completely?`
      )
    ) {
      return;
    }
    try {
      const res = await api.post("/groups/remove-user", {
        groupId,
        userId,
      });
      toast.success(res.data.message);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error("Remove user error:", err);
      toast.error("Failed to remove user from group");
    }
  };

  const participants = getParticipants(group);

  return {
    participants,
    handleTogglePermission,
    handleRemoveUserFromGroup,
  };
};

export default useParticipants;
